// quiz-upsell.js
(function initQuizUpsell() {
  window.CatQuiz = window.CatQuiz || {};

  const recipeLogic = () => window.CatQuizRecipeLogic || CatQuiz.recipeLogic;

  const state = {
    showAll: false,
    bound: false
  };

  function getRoot() {
    return recipeLogic()?.getRoot?.() || document.getElementById("cat-nutrition-quiz");
  }

  function getForm(root = getRoot()) {
    return recipeLogic()?.getForm?.(root) || root?.querySelector?.("#cat-quiz-form") || null;
  }

  function getStep(root = getRoot()) {
    return root?.querySelector?.('.quiz-step[data-step="10"]') || null;
  }

  function openModal(variantId) {
    const recipe = recipeLogic()?.getCatalog?.().find((item) => item.variantId === Number(variantId));
    if (!recipe) return;

    let overlay = document.querySelector(".quiz-upsell-modal-overlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "quiz-upsell-modal-overlay";
      overlay.hidden = true;
      overlay.innerHTML = `
        <div class="quiz-upsell-modal" role="dialog" aria-modal="true" aria-labelledby="quiz-upsell-modal-title">
          <button
            type="button"
            class="quiz-upsell-modal__close"
            data-upsell-modal-close
            aria-label="Schließen"
          >×</button>
          <div class="quiz-upsell-modal__inner">
            <h4 class="quiz-upsell-modal__title" id="quiz-upsell-modal-title"></h4>
            <div class="quiz-upsell-modal__section">
              <div class="quiz-upsell-modal__label">Inhaltsstoffe</div>
              <div class="quiz-upsell-modal__content"></div>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(overlay);
    }

    const closeBtn = overlay.querySelector("[data-upsell-modal-close]");
    const modalEl = overlay.querySelector(".quiz-upsell-modal");

    if (closeBtn) {
      closeBtn.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      };
    }

    overlay.onclick = (event) => {
      if (event.target === overlay) {
        closeModal();
      }
    };

    if (modalEl) {
      modalEl.onclick = (event) => {
        event.stopPropagation();
      };
    }

    if (!overlay.__upsellEscBound) {
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !overlay.hidden) {
          closeModal();
        }
      });
      overlay.__upsellEscBound = true;
    }

    const details = recipeLogic()?.recipeDetails?.(recipe) || { title: recipe.fallbackTitle };
    const title = details?.title || recipe.fallbackTitle;
    const contentHtml = Array.isArray(recipe.ingredients) && recipe.ingredients.length
      ? `<ul class="quiz-upsell-modal__list">${recipe.ingredients.map((item) => `<li>${recipeLogic()?.escapeHtml?.(item) || item}</li>`).join("")}</ul>`
      : `<p>Inhaltsstoffe folgen.</p>`;

    overlay.querySelector(".quiz-upsell-modal__title").textContent = title;
    overlay.querySelector(".quiz-upsell-modal__content").innerHTML = contentHtml;
    overlay.hidden = false;
    document.documentElement.classList.add("modal-open");
    document.body.classList.add("modal-open");
  }

  function closeModal() {
    const overlay = document.querySelector(".quiz-upsell-modal-overlay");
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
  }

  function cardHtml(recipe, selected) {
    const details = recipeLogic()?.recipeDetails?.(recipe) || { title: recipe.fallbackTitle, priceCents: null };
    const title = details?.title || recipe.fallbackTitle;
    const price = recipeLogic()?.formatPrice?.(details?.priceCents) || "–";
    const addLabel = selected ? "Hinzugefügt" : "Rezept hinzufügen";
    const addClass = selected ? " is-selected" : "";

    return `
      <article class="quiz-upsell-card" data-recipe-card data-variant-id="${recipe.variantId}">
        <div class="quiz-upsell-card__body">
          <h5 class="quiz-upsell-card__title">${recipeLogic()?.escapeHtml?.(title) || title}</h5>
          <div class="quiz-upsell-card__price">${recipeLogic()?.escapeHtml?.(price) || price}</div>
          <button type="button" class="quiz-upsell-card__info" data-upsell-info="${recipe.variantId}">
            Mehr Infos
          </button>
        </div>

        <div class="quiz-upsell-card__footer">
          <button
            type="button"
            class="quiz-upsell-card__add${addClass}"
            data-upsell-toggle="${recipe.variantId}"
            aria-pressed="${selected ? "true" : "false"}"
          >
            ${recipeLogic()?.escapeHtml?.(addLabel) || addLabel}
          </button>
        </div>
      </article>
    `;
  }

  function renderStep(context = {}) {
    const root = context.quizRoot || getRoot();
    const form = context.form || getForm(root);
    const stepEl = getStep(root);
    if (!root || !form || !stepEl) return;

    const upsellRoot = stepEl.querySelector("[data-upsell-root]");
    const grid = stepEl.querySelector("[data-upsell-grid]");
    const empty = stepEl.querySelector("[data-upsell-empty]");
    const actions = stepEl.querySelector("[data-upsell-actions]");
    const showMoreBtn = stepEl.querySelector("[data-upsell-show-more]");
    if (!upsellRoot || !grid || !empty || !actions || !showMoreBtn) return;

    const flow = recipeLogic()?.normalizeFlow?.(context.answers?.foodChoice || recipeLogic()?.getCurrentFlow?.(form));
    const eligible = recipeLogic()?.isStepUpsellEligible?.(flow);
    const catalog = recipeLogic()?.getCatalog?.() || [];
    const selected = new Set(recipeLogic()?.readSelectedIds?.(form) || []);

    if (!eligible) {
      upsellRoot.hidden = true;
      grid.innerHTML = "";
      empty.hidden = true;
      actions.hidden = true;
      showMoreBtn.hidden = true;
      showMoreBtn.textContent = "Mehr Rezepte anzeigen";
      showMoreBtn.setAttribute("aria-expanded", "false");
      return;
    }

    upsellRoot.hidden = false;

    if (!catalog.length) {
      grid.innerHTML = "";
      empty.hidden = false;
      actions.hidden = true;
      showMoreBtn.hidden = true;
      showMoreBtn.textContent = "Mehr Rezepte anzeigen";
      showMoreBtn.setAttribute("aria-expanded", "false");
      return;
    }

    empty.hidden = true;

    const visibleRecipes = state.showAll ? catalog : catalog.slice(0, 3);
    grid.innerHTML = visibleRecipes.map((recipe) => cardHtml(recipe, selected.has(recipe.variantId))).join("");

    const hasMore = catalog.length > 3;
    actions.hidden = !hasMore;
    showMoreBtn.hidden = !hasMore;
    showMoreBtn.textContent = state.showAll ? "Weniger anzeigen" : "Mehr Rezepte anzeigen";
    showMoreBtn.setAttribute("aria-expanded", state.showAll ? "true" : "false");
  }

  function bindUi() {
    if (state.bound) return;

    const root = getRoot();
    const form = getForm(root);
    const stepEl = getStep(root);
    if (!root || !form || !stepEl) return;

    stepEl.addEventListener("click", (event) => {
      const showMoreBtn = event.target.closest("[data-upsell-show-more]");
      if (showMoreBtn) {
        event.preventDefault();
        state.showAll = !state.showAll;
        renderStep({ quizRoot: root, form });
        return;
      }

      const infoBtn = event.target.closest("[data-upsell-info]");
      if (infoBtn) {
        event.preventDefault();
        openModal(Number(infoBtn.dataset.upsellInfo));
        return;
      }

      const toggleBtn = event.target.closest("[data-upsell-toggle]");
      if (toggleBtn) {
        event.preventDefault();
        recipeLogic()?.toggleSelectedId?.(Number(toggleBtn.dataset.upsellToggle), form);
        renderStep({ quizRoot: root, form });
      }
    });

    state.bound = true;
  }

  function buildCartItems(context = {}) {
    const form = context.form || getForm();
    const flow = recipeLogic()?.normalizeFlow?.(context.answers?.foodChoice || recipeLogic()?.getCurrentFlow?.(form));
    if (!recipeLogic()?.isStepUpsellEligible?.(flow)) return [];
    return recipeLogic()?.buildCartItems?.({ form, answers: context.answers, quizRoot: context.quizRoot }) || [];
  }

  function init() {
    const root = getRoot();
    const form = getForm(root);
    const stepEl = getStep(root);
    if (!root || !form || !stepEl) return;

    recipeLogic()?.ensureSelectionField?.(form);
    bindUi();
    const hydratePromise = recipeLogic()?.hydrateCatalog?.();
    if (hydratePromise && typeof hydratePromise.then === "function") {
      hydratePromise
        .then(() => renderStep({ quizRoot: root, form }))
        .catch(() => {});
    }
  }

  const api = {
    refreshStep: renderStep,
    buildCartItems,
    closeModal
  };

  window.CatQuizUpsell = api;
  CatQuiz.upsell = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
